export const AMPLITUDE_DASHBOARDMENU = {
  ESTADISTICAS: 'Stats Viewed',
  ADMINISTRAR: 'Administration Viewed',
  PROYECTOS: 'Projects Tab Viewed',
  BILLING: 'Billing Tab Viewed',
  PAYMENT_METHODS: 'Payment Methods Viewed',
  SKILL_IQ: 'Skill Tab Viewed',
  CLASSROOM: 'Classroom Tab Viewed',
  INTEGRACIONES: 'Integrations Tab Viewed',
  CONFIGURACION: 'Configuration Tab Viewed',
  AYUDA: 'Help Tab Viewed',
  FEEDBACK: 'Feedback Tab Viewed',
  GUIA_DEL_ADMINISTRADOR: 'Admin Guide Tab Viewed',
  STUDIO: 'Elevate LMS Tab Viewed',
  SKILL_XP_EVOLUTION: 'Skill XP Evolution Viewed',
  TALENTO: 'Talent Tab Viewed',
};
